import gql from 'graphql-tag';

const GET_CATALOG_SPEC = gql`
  query catalogSpec($catalogSpecId: String!) {
    catalogSpec: getCatalogSpec(catalogSpecId: $catalogSpecId) {
      id,
      label,
      name,
      coverImageUrl,
      featuredWords,
      featuredProducts {
        id,
        inRutaShortDescriptionSpanish
      }
    }
  }
`;

export default GET_CATALOG_SPEC;
